import { parse } from '@o3co/ts.hocon';

/** Returns `true` when `value` is empty or valid HOCON. */
export const isValidHocon = (value: string | undefined): boolean => {
  const trimmed = value?.trim();
  if (!trimmed) {
    return true;
  }

  try {
    parse(trimmed);
    return true;
  } catch {
    return false;
  }
};
